import { render, staticRenderFns } from "./ListPrixOfInstitution.vue?vue&type=template&id=03ae1d5c&scoped=true"
import script from "./ListPrixOfInstitution.vue?vue&type=script&lang=js"
export * from "./ListPrixOfInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ae1d5c",
  null
  
)

export default component.exports